import { ConfigService, getConfigService } from 'src/services';

import { AccountApplicationApi } from './AccountApplicationApi';
import { AccountHolderApi } from './AccountHolderApi';
import { AccountApi } from './AccountsApi';
import { BalanceApi } from './BalanceApi';
import { InvestigationsApi } from './InvestigationsApi';
import { OfferOrdersApi } from './OfferOrdersApi';
import { OrdersApi } from './OrdersApi';
import { PositionApi } from './PositionApi';
import { PrivateQuotesApi } from './PrivateQuotesApi';
import { QuoteApi } from './QuoteApi';
import { StatementsApi } from './StatementsApi';

export class ClientApi {
  accountApplication: AccountApplicationApi;
  account: AccountApi;
  accountHolder: AccountHolderApi;
  balance: BalanceApi;
  investigations: InvestigationsApi;
  statements: StatementsApi;
  orders: OrdersApi;
  position: PositionApi;
  offerOrders: OfferOrdersApi;
  privateQuotes: PrivateQuotesApi;
  quote: QuoteApi;

  constructor(configService: ConfigService) {
    this.accountApplication = new AccountApplicationApi(configService);
    this.account = new AccountApi(configService);
    this.accountHolder = new AccountHolderApi(configService);
    this.balance = new BalanceApi(configService);
    this.investigations = new InvestigationsApi(configService);
    this.statements = new StatementsApi();
    this.orders = new OrdersApi();
    this.position = new PositionApi();
    this.offerOrders = new OfferOrdersApi();
    this.privateQuotes = new PrivateQuotesApi();
    this.quote = new QuoteApi();
  }
}

const clientApi = new ClientApi(getConfigService());

export const getClientApi = () => {
  return clientApi;
};
